/**
 * RootRoute — picks the correct landing page based on hostname.
 *
 * Each Wavlynq sibling app can be served from its own domain. When the
 * hostname matches an app domain, `/` renders that app's landing page
 * instead of the umbrella Index.
 *
 * See src/lib/hostname/appForHost.ts for the host map.
 */
import Index from "@/pages/Index";
import Fryqnc from "@/pages/apps/Fryqnc";
import Pulsynq from "@/pages/apps/Pulsynq";
import MindLynq from "@/pages/apps/MindLynq";
import Ablelynq from "@/pages/apps/Ablelynq";
import Deafwav from "@/pages/apps/Deafwav";
import Fullynq from "@/pages/apps/Fullynq";
import Jadesynq from "@/pages/apps/Jadesynq";
import Openlynq from "@/pages/apps/Openlynq";
import Spiritsynq from "@/pages/apps/Spiritsynq";
import { getAppForHost } from "@/lib/hostname/appForHost";

const RootRoute = () => {
  const app = getAppForHost();
  switch (app) {
    case "fryqnc":   return <Fryqnc />;
    case "pulsynq":   return <Pulsynq />;
    case "mindlynq":  return <MindLynq />;
    case "ablelynq":  return <Ablelynq />;
    case "deafwav":   return <Deafwav />;
    case "fullynq":   return <Fullynq />;
    case "jadesynq":  return <Jadesynq />;
    case "openlynq":  return <Openlynq />;
    case "spiritsynq":return <Spiritsynq />;
    case "wavlynq":
    default:          return <Index />;
  }
};

export default RootRoute;
